import StoryblokButton from "components/DynamicComponent/atoms/StoryblokButton"

export default function DualButton({ blok }) {
  return (
    <div className="flex flex-col lg:flex-row gap-4 items-start">
      {blok.buttons.map((button, idx) => (
        <StoryblokButton blok={button} key={idx} />
      ))}
    </div>
  )
}
